import { AuthContext } from "@otel-lisanslama/contexts/AuthContext";
import { useContext } from "react";

const useAuthProvider = () => useContext(AuthContext);

export default useAuthProvider;
